module.exports = __webpack_public_path__ + "static/img/jiangpai.6a001ea2.png";